export var flattenMessages = function (nestedMessages, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return Object.keys(nestedMessages).reduce(function (messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        }
        else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }
        return messages;
    }, {});
};
